<template>
	<div id="indexM">
		<div class="coLogoLan">
			<img class="coLogo" mode="widthFix" src="../../static/pic/logo_hudie0@2x.png" />
		</div>
		<div id="id1" style="width: 100%;height: img_height + 'px';margin-top: 2px;">
			<!-- <el-carousel class="banner" trigger="click" :height="windowHeight+'px'" :autoplay="true" :interval="3000"> -->
			<el-carousel trigger="click" :autoplay="true" :height="final_img_height" :interval="3000">
				<el-carousel-item v-for="(item,index) in bannerList" :key="index">
					<img @click="jumpLink(item)" style="width: 100%;" mode="widthFix" :src="item.picUrl"
						@load="img_load" ref='img_ref' />
				</el-carousel-item>
			</el-carousel>
		</div>

		<div class="section">
			<div class="stitle">走进蝴蝶供应链</div>
			<div class="s1Piclan">
				<img class="s1Pic" mode="widthFix" src="../../static/mobilePic/img_hudiedemo@2x.png" />
			</div>
			<div class="s1txt">
				蝴蝶供应链有限公司有着十二年的工程机械行业经验和资源沉淀，同时拥有专业的软件开发团队和互联网运营经验，是一家以技术为驱动、数字化解决方案为核心的公司。公司以推动工程机械行业转型为目标，为行业赋能，实现行业的信息化、数字化、智能化，达到降本增效的目的。
			</div>
		</div>

		<div class="section" style="margin-top: 12px;">
			<div class="stitle">蝴蝶供应链“创世蜜蜂APP”电商平台</div>
			<div class="s2Piclan">
				<img class="s2Pic" mode="widthFix" src="../../static/indexPic/img_web03_appmodel.png" />
			</div>
			<div class="s2txt">
				创世蜜蜂APP是一款工程机械综合服务平台，囊括了八大业务——零配件商城更给力，配件种类全、品质优、价更低，电子签流程完整，更具法律效力；可以一对一租赁设备，线上签约电子合同，回款有保障；二手机交易价格自由，求购更精准；资讯快人一步，成功更进一步；机手招聘求职效率高、匹配准、更省力；大件物流不只是速度，还有放心；设备坏了不愁，在线一点即修；专门的金融方案蜜蜂白条，额度高、利息低、放款快、账期长，八大业务共同助力工程企业突破发展困局，蓬勃发展。
			</div>
			<div class="s2bottomtxt">专业的工程机械零配件在线商城</div>
			<div class="s2bottomLan">
				<div style="width: 43px;height: 1px;background: #999999;"></div>
				<div class="s2bottomTitle">创世蜜蜂</div>
				<div style="width: 43px;height: 1px;background: #999999;"></div>
			</div>
		</div>

		<div class="section" style="margin-top: 10px;">
			<div class="stitle">主营业务</div>
			<div class="redAgreen">
				<div class="red"></div>
				<div class="green"></div>
			</div>
			<div class="s3boxArea">
				<div class="s3boxLan">
					<div class="s3box">
						<div class="s3boxNum">01</div>
						<div class="s3imgLan">
							<img style="width: 3.75rem;height: 3.75rem;" mode="widthFix"
								src="../../static/indexPic/icon_home_yw01.png" />
						</div>
						<div class="s3boxtxt">电商一体化</div>
					</div>
					<div class="s3box">
						<div class="s3boxNum">02</div>
						<div class="s3imgLan">
							<img style="width: 3.75rem;height: 3.75rem;" mode="widthFix"
								src="../../static/indexPic/icon_home_yw02.png" />
						</div>
						<div class="s3boxtxt">挂账协议方案</div>
					</div>
				</div>
				<div class="s3boxLan">
					<div class="s3box">
						<div class="s3boxNum">03</div>
						<div class="s3imgLan">
							<img style="width: 3.75rem;height: 3.75rem;" mode="widthFix"
								src="../../static/indexPic/icon_home_yw03.png" />
						</div>
						<div class="s3boxtxt">电子发票</div>
					</div>
					<div class="s3box">
						<div class="s3boxNum">04</div>
						<div class="s3imgLan">
							<img style="width: 3.75rem;height: 3.75rem;" mode="widthFix"
								src="../../static/indexPic/icon_home_yw04.png" />
						</div>
						<div class="s3boxtxt">整机交易/租赁</div>
					</div>
				</div>
				<div class="s3boxLan">
					<div class="s3box">
						<div class="s3boxNum">05</div>
						<div class="s3imgLan">
							<img style="width: 3.75rem;height: 3.75rem;" mode="widthFix"
								src="../../static/indexPic/icon_home_yw05.png" />
						</div>
						<div class="s3boxtxt">云仓储/物流云</div>
					</div>
					<div class="s3box">
						<div class="s3boxNum">06</div>
						<div class="s3imgLan">
							<img style="width: 3.75rem;height: 3.75rem;" mode="widthFix"
								src="../../static/indexPic/icon_home_yw06.png" />
						</div>
						<div class="s3boxtxt">金融解决方案</div>
					</div>
				</div>
				<div class="s3boxLan">
					<div class="s3box">
						<div class="s3boxNum">07</div>
						<div class="s3imgLan">
							<img style="width: 3.75rem;height: 3.75rem;" mode="widthFix"
								src="../../static/indexPic/icon_home_yw07.png" />
						</div>
						<div class="s3boxtxt">营销矩阵</div>
					</div>
					<div class="s3box">
						<div class="s3boxNum">08</div>
						<div class="s3imgLan">
							<img style="width: 3.75rem;height: 3.75rem;" mode="widthFix"
								src="../../static/indexPic/icon_home_yw08.png" />
						</div>
						<div class="s3boxtxt">蜂豆体系</div>
					</div>
				</div>
				<!-- <div class="s3boxLan">
					<div class="s3box">
						<div class="s3boxNum">09</div>
						<div class="s3imgLan">
							<img style="width: 5.125rem;height: 5.125rem;" mode="widthFix" src="../../static/indexPic/icon_home_yw07.png" />
						</div>
						<div class="s3boxtxt">售后报修</div>
					</div>
					<div class="s3box">
						<div class="s3boxNum">10</div>
						<div class="s3imgLan">
							<img style="width: 5.125rem;height: 5.125rem;" mode="widthFix" src="../../static/indexPic/icon_home_yw08.png" />
						</div>
						<div class="s3boxtxt">招聘求职</div>
					</div>
				</div> -->
			</div>
		</div>

		<div class="section" style="margin-top: 10px;">
			<div class="stitle">平台优势</div>
			<div class="redAgreen">
				<div class="red"></div>
				<div class="green"></div>
			</div>
			<img  style="height: 100%;padding:3.125rem 1.25rem 5rem" src="../../static/mobilePic/img_tab3_3ys.png" />
			<!-- <div class="redAgreen">
				<div class="red"></div>
				<div class="green"></div>
			</div>
			<div class="s4boxArea">
				<div class="s4box">
					<div class="s4boxleft">
						<img class="s4img1" src="../../static/canvasPic/icon_web03_ys1@2x.png" />
					</div>
					<div class="s4boxright" style="margin-bottom: 20px;">
						<div class="s4boxrightTittle1">产品优势</div>
						<div class="s4boxrightLan">
							<span style="color: red;">*</span>
							<span class="s4boxrighttxt">0成本开店，帮您把生意搬到线上，让您的顾客随心所欲了解产品，享受一键采购、下单、支付、物流服务。</span>
						</div>
						<div class="s4boxrightLan">
							<span style="color: red;">*</span>
							<span class="s4boxrighttxt">无忧对账，帮您告别人工盘账，随时跟踪订单，查询客户往来款项，核对财务明细。</span>
						</div>
						<div class="s4boxrightLan">
							<span style="color: red;">*</span>
							<span class="s4boxrighttxt">良好的库存管理，实现在线进销库存管理，帮您优化采购，减少库存积压。</span>
						</div>
						<div class="s4boxrightLan">
							<span style="color: red;">*</span>
							<span class="s4boxrighttxt">供应链金融服务：平台提供挂账功能，提供蜜蜂白条、蜜蜂贷等业务，帮您实现资金快速回笼，提升资金使用效率。</span>
						</div>
					</div>
				</div>
				<div class="s4box">
					<div class="s4boxleft">
						<img class="s4img2" src="../../static/canvasPic/icon_web03_ys2@2x.png" />
					</div>
					<div class="s4boxright" style="margin-bottom: 33px;">
						<div class="s4boxrightTittle2" style="margin-top: 28px;">市场优势</div>
						<div class="s4boxrighttxt2">全方位的渠道宣传，全力度的品牌建设支持</div>
						<div class="s4boxrightTittle2">技术优势</div>
						<div class="s4boxrighttxt2">技术领先、远程协同、安全性高</div>
						<div class="s4boxrightTittle2">团队优势</div>
						<div class="s4boxrighttxt2">丰富经验的管理团队、顾问式营销团队、业务领域专家、高效率专业技术团队</div>
						<div class="s4boxrightTittle2">服务优势</div>
						<div class="s4boxrighttxt2">7×24小时客服、一对一专属顾问、优质的市场指导、完善的售后体系</div>
					</div>
				</div>
			</div> -->
		</div>

		<div class="section" style="margin-top: 10px;">
			<div class="stitle">平台支持</div>
			<div class="redAgreen">
				<div class="red"></div>
				<div class="green"></div>
			</div>
			<div class="s5boxArea">
				<div style="margin: 0 0.625rem 1.25rem;display: flex; flex-direction: column; gap: 0.625rem;">
					<img style="width:100%;height: 100%;" src="../../static/mobilePic/ptzc01.png" />
					<img style="width:100%;height: 100%;" src="../../static/mobilePic/ptzc02.png" />
					<img style="width:100%;height: 100%;" src="../../static/mobilePic/ptzc03.png" />
				</div>
				<!-- <div class="s5boxLan">
					<div class="s5box">
						<img class="s5boxPic" mode="widthFix" src="../../static/canvasPic/icon_web03_support1@2x.png" />
						<div class="s5boxtxt">提供大额金融贷款、融资服务，让商家资金充沛，进货无忧</div>
					</div>
					<div class="s5box">
						<img class="s5boxPic" mode="widthFix" src="../../static/canvasPic/icon_web03_support2@2x.png" />
						<div class="s5boxtxt">建立一站式仓储服务，商家一键发货</div>
					</div>
					<div class="s5box">
						<img class="s5boxPic" mode="widthFix" src="../../static/canvasPic/icon_web03_support3@2x.png" />
						<div class="s5boxtxt">平台收取低服务费，甚至免费，让利商家</div>
					</div>
				</div>
				<div class="s5boxLan">
					<div class="s5box">
						<img class="s5boxPic" mode="widthFix" src="../../static/canvasPic/icon_web03_support4@2x.png" />
						<div class="s5boxtxt">商家定制化功能，满足商家独立功能需求</div>
					</div>
					<div class="s5box">
						<img class="s5boxPic" mode="widthFix"
							src="../../static/canvasPic/icon_web03_support4@2x(1).png" />
						<div class="s5boxtxt">帮助商家实现全渠道推广、引流；全方位品牌建设</div>
					</div>
					<div class="s5box">
						<img class="s5boxPic" mode="widthFix" src="../../static/canvasPic/icon_web03_support6@2x.png" />
						<div class="s5boxtxt">不定期提供运营、技术、管理培训，互利共赢</div>
					</div>
				</div> -->
			</div>
		</div>

		<div class="section" style="margin-top: 10px;">
			<div class="stitle">招商入驻</div>
			<div class="redAgreen">
				<div class="red"></div>
				<div class="green"></div>
			</div>
			<div @load="img_load1" class="s6Area" :style="{'height':getHeight()}">
				<img @load="img_load1" @click="openDialog1()" ref='img_ref1' class="s6Pic" mode="widthFix"
					src="../../static/mobilePic/img_zs_banner.png" />
				<!-- <img @click="openDialog1()" class="s6Pic1" mode="widthFix" src="../../static/mobilePic/btn_ruzhu.png" /> -->
			</div>
		</div>

		<div class="section" style="margin-top: 10px;">
			<div class="stitle">下载地址</div>
			<div class="redAgreen">
				<div class="red"></div>
				<div class="green"></div>
			</div>
			<div class="s7Area">
				<div class="s7box">
					<img class="s7boxPic" mode="widthFix" src="../../static/canvasPic/icon_web03_downdz1@2x.png" />
					<div class="s7boxtxt">创世蜜蜂商家APP下载地址</div>
					<div class="s7boxLan">
						<div class="s7boxlanbox">
							<img class="s7boxboxPic" mode="widthFix" src="../../static/downLoadPic/seller.jpg" />
						</div>
					</div>
				</div>
				<div class="s7box" @click="openDialog()">
					<img class="s7boxPic" mode="widthFix" src="../../static/canvasPic/icon_web03_downdz2@2x.png" />
					<div class="s7boxtxt">商家端管理后台地址</div>
					<div class="s7boxtxt1">http://seller.hudiejx.com/</div>
				</div>
			</div>
		</div>


		<el-dialog title="温馨提示" custom-class="dialogClass" :visible.sync="open" width="300px">
			<div class="dialogArea">
				<div class="dialogtxt">请前往商家端后台PC端进行设置，地址：http://seller.hudiejx.com/</div>
				<div class="btnLan">
					<div class="cancelBtn" @click="cancel()">取消</div>
					<div class="copyBtn" @click="copy()" data-clipboard-text="http://seller.hudiejx.com/">复制地址</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog title="提交信息" custom-class="dialogClass" :visible.sync="open1" width="300px">
			<div style="width: calc(100% - 30px);padding-left: 15px;">
				<el-form :model="form" :rules="rules" ref="form">
					<el-form-item label="姓名" prop="name">
						<el-input v-model="form.name" placeholder="输入姓名"></el-input>
					</el-form-item>
					<el-form-item label="公司名称" prop="companyName">
						<el-input v-model="form.companyName" placeholder="输入公司名称"></el-input>
					</el-form-item>
					<el-form-item label="电话号码" prop="tel">
						<el-input v-model="form.tel" placeholder="输入电话号码"></el-input>
					</el-form-item>
					<el-form-item label="职位" prop="position">
						<el-input v-model="form.position" placeholder="输入职位"></el-input>
					</el-form-item>
				</el-form>
				<div class="submitLan">
					<div class="submitBtn" @click="submitForm()">提交</div>
				</div>
			</div>

		</el-dialog>

		<mobile-bottom-area></mobile-bottom-area>

	</div>

</template>

<script>
	import {
		bannerList
	} from "../../api/index.js"
	import mobileBottomArea from "../components/mobileBottomArea.vue"
	import Clipboard from 'clipboard';
	import {
		enroll
	} from "../../api/canvass.js"
	export default {
		components: {
			mobileBottomArea
		},
		data() {
			var checkName = (rule, value, callback) => {
				if (value == null || value == '') {
					callback(new Error('联系人不能为空'));
				} else {
					callback();
				}
			}
			var checkJob = (rule, value, callback) => {
				if (value == null || value == '') {
					callback(new Error('职位不能为空'));
				} else {
					callback();
				}
			}
			var checkTel = (rule, value, callback) => {
				if (value == null || value == '') {
					callback(new Error('联系电话不能为空'));
				} else {
					if (value.length !== 11) {
						callback(new Error('请输入11位手机号'));
					} else {
						callback();
					}
				}
			}
			var checkCoName = (rule, value, callback) => {
				if (value == null || value == '') {
					callback(new Error('公司名不能为空'));
				} else {
					callback();
				}
			}
			return {
				bannerList: [],
				img_height: '',
				final_img_height: "",
				img_height1: '',
				open: false,
				open1: false,
				toastShow: false,
				toastText: "",
				form: {},
				rules: {
					name: [{
						validator: checkName,
						trigger: 'blur'
					}],
					companyName: [{
						validator: checkCoName,
						trigger: 'blur'
					}],
					position: [{
						validator: checkJob,
						trigger: 'blur'
					}],
					tel: [{
						validator: checkTel,
						trigger: 'blur'
					}],
				}
			}
		},
		created() {
			document.documentElement.scrollTop = 0
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			this.getBannerList()
		},
		methods: {
			img_load() {
				this.final_img_height = 10.5 + 'rem'
				// this.img_height = this.$refs.img_ref[0].height
				// alert(this.$refs.img_ref[0].height)
				// console.log(this.$refs.img_ref[0])
				// this.final_img_height = this.img_height + 'px'
			},
			img_load1() {
				this.img_height1 = this.$refs.img_ref1.height
			},
			getHeight() {
				var height = this.img_height1 + 'px'
				return height
			},
			handleScroll() {
				let _this = this;
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				if (scrollTop) {
					_this.scrollFlag = true
				} else {
					_this.scrollFlag = false
				}
			},
			openDialog() {
				this.open = true
			},
			cancel() {
				this.open = false
			},
			openDialog1() {
				this.open1 = true
			},
			cancel1() {
				this.open1 = false
			},
			copy() {
				var clipboard = new Clipboard('.copyBtn')
				var that = this
				clipboard.on('success', e => {
					// 释放内存
					clipboard.destroy()
					this.open = false
					this.$showToast.show('复制成功!')
					setTimeout(function() {
						that.delModal()
					}, 1500)
				})
				clipboard.on('error', e => {
					// 不支持复制
					console.log('该浏览器不支持自动复制')
					// 释放内存
					clipboard.destroy()
				})
			},
			delModal() {
				this.$showToast.hide()
			},
			submitForm() {
				var that = this
				this.$refs["form"].validate(valid => {
					if (valid) {
						enroll(this.form).then(res => {
							if (res.code == 200) {
								this.$showToast.show('提交成功，我们稍后会与您联系!')
								this.cancel1()
								setTimeout(function() {
									that.delModal()
								}, 2000)
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						this.$showToast.show('请完整填写信息后再提交!')
						setTimeout(function() {
							that.delModal()
						}, 2000)
					}
				});
			},
			jumpLink(item) {
				if (item.hyperLink !== null && item.hyperLink !== "") {
					window.open(item.hyperLink, '_blank')
				} else {

				}
			},
			getBannerList() {
				bannerList().then(res => {
					this.bannerList = res.data
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style scoped="scoped">
	#indexM {
		width: 100%;
		/* height: 100%; */
		background-color: #f4f4f4;
		overflow: hidden;
	}

	.coLogoLan {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #FFFFFF;
	}

	.coLogo {
		width: 35%;
	}

	.section {
		width: 100%;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
	}

	.stitle {
		padding-top: 24px;
		width: 100%;
		text-align: center;
		font-size: 15px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #222222;
	}

	.s1Piclan {
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top: 33px;
	}

	.s1Pic {
		width: 14.25rem;
		height: 9.75rem;
	}

	.s1txt {
		margin-top: 6px;
		margin-bottom: 30px;
		width: calc(100% - 30px);
		padding-left: 15px;
		font-size: 11px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #222222;
		text-align: left;
	}

	.s2Piclan {
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top: 40px;
	}

	.s2Pic {
		width: 14.375rem;
		height: 9.75rem;
	}

	.s2txt {
		margin-top: 22px;
		width: calc(100% - 30px);
		padding-left: 15px;
		font-size: 11px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #222222;
		text-align: left;
	}

	.s2bottomtxt {
		margin-top: 28px;
		width: 100%;
		text-align: center;
		font-size: 7px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
	}

	.s2bottomLan {
		margin-top: 4px;
		height: 9px;
		margin-bottom: 11px;
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}

	.s2bottomTitle {
		font-size: 9px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
		margin: 0px 4px;
	}

	.redAgreen {
		margin-top: 5px;
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.red {
		width: 10px;
		height: 2px;
		background: #E70A1B;
	}

	.green {
		width: 27px;
		height: 2px;
		background: #467CFD;
	}

	.s3boxArea {
		width: calc(100% - 30px);
		margin-top: 30px;
		padding-left: 15px;
		margin-bottom: 20px;
	}

	.s3boxLan {
		width: 100%;
		display: flex;
		margin-bottom: 10px;
		justify-content: space-between;
	}

	.s3box {
		position: relative;
		width: 167px;
		height: 100px;
		background: #FFFFFF;
		border: 1px solid #EEEEEE;
		border-radius: 2px;
	}

	.s3boxNum {
		position: absolute;
		top: 7px;
		right: 9px;
		font-size: 10px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #999999;
	}

	.s3boxtxt {
		position: absolute;
		width: 100%;
		text-align: center;
		bottom: 0.625rem;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #222222;
	}

	.s3imgLan {
		position: absolute;
		width: 100%;
		display: flex;
		justify-content: center;
		/* bottom: 50px; */
		top: 0.625rem;
	}

	.s4boxArea {
		margin-top: 24px;
	}

	.s4box {
		display: flex;
		flex-direction: row;
		width: calc(100% - 30px);
		margin-bottom: 15px;
		margin-left: 15px;
		/* height: 258px; */
		background: #FFFFFF;
		border: 1px solid #467CFD;
		border-radius: 2px;
	}

	.s4boxleft {
		width: 102px;
		position: relative;
	}

	.s4img1 {
		position: absolute;
		left: 40px;
		top: 18px;
		width: 41px;
		height: 41px;
	}

	.s4img2 {
		position: absolute;
		left: 50px;
		top: 30px;
		width: 36px;
		mode: widthFix
	}

	.s4boxright {
		width: calc(100% - 102px);
		text-align: left;
	}

	.s4boxrightTittle1 {
		margin-top: 18px;
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #010101;
	}

	.s4boxrightLan {
		width: 100%;
		margin-top: 18px;
		display: flex;
	}

	.s4boxrighttxt {
		width: 195px;
		font-size: 10px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #060001;
		line-height: 13px;
	}

	.s4boxrightTittle2 {
		margin-top: 15px;
		font-size: 10px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #010101;
	}

	.s4boxrighttxt2 {
		width: 190px;
		font-size: 9px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #060001;
		line-height: 11px;
		margin-top: 10px;
	}

	.s5boxArea {
		/* width: calc(100% - 30px); */
		/* padding-left: 15px; */
		margin-top: 24px;
		/* margin-bottom: 15px; */
		/* display: flex;
		flex-direction: column; */
	}

	.s5boxLan {
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-bottom: 15px;
	}

	.s5box {
		position: relative;
		display: flex;
		justify-content: center;
		width: 105px;
		height: 118px;
		background: #FFFFFF;
		border: 1px solid #467CFD;
		border-radius: 8px 0px 8px 0px;
	}

	.s5boxPic {
		position: absolute;
		width: 27px;
		bottom: 70px;
	}

	.s5boxtxt {
		position: absolute;
		top: 65px;
		width: 80px;
		text-align: left;
		font-size: 7px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: 9px;
	}

	.s6Area {
		width: 100%;
		display: flex;
		justify-content: center;
		position: relative;
		margin-top: 18px;
	}

	.s6Pic {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
	}

	.s6Pic1 {
		position: absolute;
		width: 28%;
		bottom: 25px;
	}

	.s7Area {
		width: calc(100% - 30px);
		padding-left: 15px;
		margin-top: 23px;
		display: flex;
		justify-content: space-between;
		margin-bottom: 30px;
	}

	.s7box {
		display: flex;
		flex-direction: column;
		/* justify-content: center; */
		align-items: center;
		width: 167px;
		height: 156px;
		background: #FFFFFF;
		border: 1px solid #EEEEEE;
		border-radius: 2px;
	}

	.s7boxPic {
		margin-top: 17px;
		width: 32px;
	}

	.s7boxtxt {
		width: 100%;
		text-align: center;
		margin-top: 7px;
		font-size: 10px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #222222;
		line-height: 18px;
	}

	.s7boxLan {
		margin-top: 20px;
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.s7boxlanbox {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 75px;
	}

	.s7boxboxPic {
		width: 46px;
	}

	.s7boxboxtxt {
		width: 100%;
		text-align: center;
		font-size: 6px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #010101;
		margin-top: 5px;
	}

	.s7boxtxt1 {
		width: 100%;
		text-align: center;
		font-size: 10px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #010101;
		margin-top: 43px;
	}

	/deep/ .el-dialog.dialogClass {
		border-radius: 12px;
	}

	/deep/ .el-dialog__title {
		font-size: 15px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #222222;
	}

	/deep/ .el-dialog__body {
		padding: 0 0 20px 0
	}

	/deep/ .el-message.el-message--success {
		min-width: 0px !important;
		/* width: 200px; */
	}

	/* /deep/ .el-message--success{
		color: red;
	} */
	.dialogArea {
		width: calc(100% - 40px);
		padding-left: 20px;
	}

	.dialogtxt {
		width: 100%;
		text-align: center;
		margin-top: 20px;
	}

	.btnLan {
		margin-top: 40px;
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.cancelBtn {
		width: 125px;
		height: 45px;
		background: #E3E3E3;
		border-radius: 23px;
		line-height: 45px;
		text-align: center;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
	}

	.copyBtn {
		width: 125px;
		height: 45px;
		background: #467CFD;
		border-radius: 23px;
		line-height: 45px;
		text-align: center;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
	}

	.submitLan {
		width: 100%;
		display: flex;
		align-items: center;
		margin-top: 27px;
		justify-content: center;
	}

	.submitBtn {
		width: 175px;
		height: 45px;
		background: #467CFD;
		border-radius: 23px;
		line-height: 45px;
		text-align: center;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
	}
</style>